import { createTheme, ThemeOptions } from "@mui/material/styles";

const primaryColor = "#002050";
const secondaryColor = "#dc3c00";
const options: ThemeOptions = {
  palette: {
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
  },
  typography: {
    fontFamily: "Open Sans",
  },
};

const theme = createTheme(options);

theme.components = {
  ...theme.components,
  MuiTextField: {
    defaultProps: {
      fullWidth: true,
      size: "small",
    },
  },
  MuiButton: {
    defaultProps: {
      variant: "contained",
      color: "secondary",
    },
  },
  MuiRadio: {
    defaultProps: {
      color: "secondary",
    },
  },
  MuiPagination: {
    defaultProps: {
      variant: "outlined",
      shape: "rounded",
      color: "secondary",
      showFirstButton: true,
      showLastButton: true,
    },
  },
  MuiPaginationItem: {
    styleOverrides: {
      outlined: {
        color: theme.palette.secondary.main,
      },
      outlinedSecondary: {
        "&.Mui-selected": {
          color: theme.palette.common.white,
          backgroundColor: theme.palette.secondary.main,
          "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
          },
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: {
        padding: theme.spacing(1),
        fontWeight: "bold",
      },
      body: {
        padding: theme.spacing(1),
        verticalAlign: "middle",
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: theme.spacing(3, 2),
      },
    },
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
    },
  },
  MuiButtonGroup: {
    defaultProps: {
      variant: "contained",
      color: "secondary",
    },
  },
};

export default theme;
